import { UseMutationOptions } from 'react-query';
import { CampaignType, CuredApiPaths } from 'models/enums';
import useMutation from '../useMutation';
import MutationKeys from './keys';

export type CreateDraftCampaignMutationInput = {
    name: string;
    type?: CampaignType;
    sends?: any[]; // More flexible for drafts - can handle various send states
    abTestConfig?: any;
    reentryDetails?: any;
    [key: string]: any; // Allow additional properties for flexibility
};

type CreateDraftCampaignResponse = { id: string };

/**
 * Creates a draft campaign using POST /campaign/draft
 * @param mutateOptions react-query useMutation option
 * @returns the react-query useMutation results
 * See https://react-query-v3.tanstack.com/reference/useMutation for options and return value
 */
const useCreateDraftCampaign = (
    mutateOptions?: UseMutationOptions<CreateDraftCampaignResponse, Error, CreateDraftCampaignMutationInput>
) =>
    useMutation<CreateDraftCampaignMutationInput, CreateDraftCampaignResponse>(
        MutationKeys.CREATE_DRAFT_CAMPAIGN,
        `${CuredApiPaths.CAMPAIGNS_DRAFT}`,
        mutateOptions
    );

export default useCreateDraftCampaign;
